import {
  OnFetchCompleted,
  OnFetchStarted
} from './fetch.types'

export const FETCH_STARTED = 'FETCH_STARTED'
export const FETCH_COMPLETED = 'FETCH_COMPLETED'

export const onFetchStarted: OnFetchStarted = () => ({
  type: FETCH_STARTED
})

export const onFetchCompleted: OnFetchCompleted = () => ({
  type: FETCH_COMPLETED
})
